import React from 'react';
import { getInitials } from '@guryou/utils';
import { Avatar as MuiAvatar } from '@material-ui/core';
import Badge from '@material-ui/core/Badge';
import styled from 'styled-components';
import { stringToColor } from './stringToColor';
const CustomMuiAvatar = styled(MuiAvatar)`
  &:hover {
    opacity: 0.9;
    cursor: pointer;
  }
`;
const Avatar = ({
  text,
  imageSrc,
  imageAlt,
  onClick,
  icon,
  size = 'small',
  border = false
}) => {
  let content;
  if (imageSrc) {
    content = /*#__PURE__*/React.createElement(CustomMuiAvatar, {
      className: `${size} ${border && 'border'}`,
      onClick: onClick,
      src: imageSrc,
      alt: imageAlt
    });
  } else {
    content = /*#__PURE__*/React.createElement(CustomMuiAvatar, {
      className: `${size} ${border && 'border'}`,
      onClick: onClick,
      style: {
        backgroundColor: stringToColor(text)
      }
    }, getInitials(text));
  }
  if (!icon) {
    return content;
  }
  return /*#__PURE__*/React.createElement(Badge, {
    overlap: "circle",
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    badgeContent: icon
  }, content);
};
export { Avatar };